angular.module("listingOverviewModule").component("listingDescription", {
    templateUrl: "listingDescription/listingDescription.html",
    bindings: {
        title: '<',
        listingDetails: '<',
        description: '<',
        highlights: '<',
        viewed: '@'
    },
    controller: ["$scope", "$sce", "$element", "$timeout", function($scope, $sce, $element, $timeout) {
        var self = this;

        this.showReadMore = true;
        this.showAllParagraphs = false;

        this.$onInit = function () {
            this.trustedDescription = $sce.trustAsHtml(this.description);
            this.trustedHighlights = this.highlights.map(function (highlight) {
                return $sce.trustAsHtml(highlight);
            });
            this.trustedListingDetails = $sce.trustAsHtml(this.listingDetails || '');
        };

        this.$postLink = function () {
            $timeout(() => {
                let observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            let descriptionElement = $element[0].querySelector('.description-content');
                            if (descriptionElement && descriptionElement.scrollHeight <= 340) {
                                // If content height is small, hide "Read More"
                                self.showReadMore = false;
                            }
                            observer.disconnect(); // Stop observing once condition is checked
                        }
                    });
                });

                observer.observe($element[0]);
            }, 300);
        };

        this.toggleReadMore = function () {
            this.showAllParagraphs = !this.showAllParagraphs;

            // Dynamically update class
            let descriptionElement = $element[0].querySelector('.description-content');
            if (descriptionElement) {
                if (this.showAllParagraphs) {
                    descriptionElement.classList.remove('collapsed');
                    descriptionElement.classList.add('expanded');
                } else {
                    descriptionElement.classList.remove('expanded');
                    descriptionElement.classList.add('collapsed');
                }
            }
        };
    }]
});
